// @flow

import {reduxForm} from 'redux-form';
import RoomForm from './RoomForm';

export default reduxForm({
  form: 'configTemplateRoom',
  enableReinitialize: true,
})(RoomForm);



// WEBPACK FOOTER //
// ./src/components/RoomForm/ConfigTemplateRoomForm.js